export default __webpack_public_path__ + "static/media/onboarding_imgs_03.39782159.png";